import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/getSeconds/index.js';

var require$$18 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$18 as default };
